import { render } from "./GameDeduction.vue?vue&type=template&id=27707ad6&scoped=true"
import script from "./GameDeduction.vue?vue&type=script&lang=js"
export * from "./GameDeduction.vue?vue&type=script&lang=js"

import "./GameDeduction.vue?vue&type=style&index=0&id=27707ad6&scoped=scoped&lang=less"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27707ad6"]])

export default __exports__